import axios from 'axios'
import decode from 'jwt-decode'

import { removeSecurityToken, saveSecurityToken } from '../../security/securityContext'

import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { AUTHENTICATION_FAILED, USER_AUTHENTICATED, USER_LOGOUT } from '../types'
import { URL } from '../../util/ambienteActions';

const authenticationUrl = `${URL}/auth/signin`

export function validarToken (token) {
  const dataToken = decode(token).exp;
  // eslint-disable-next-line radix
  const dataCorrente = parseInt(Date.now() / 1000);
  return dataToken > dataCorrente
}

export function isUserAuthenticated (auth) {
  return auth && auth.isAuthenticated && auth.tokenJwt && validarToken(auth.tokenJwt)
}

export function ordenarEmpresas (empresas) {
  return empresas.sort((n1, n2) => {
    if (n1.nome > n2.nome) {
      return 1;
    }

    if (n1.nome < n2.nome) {
      return -1;
    }

    return 0;
  })
}

export const authenticateUser = data => dispatch => axios.post(authenticationUrl, data, SLOW_REQUEST_CONFIG)
  .then((response) => {
    const usuarioAutenticado = response.data

    const tokenDecodificado = decode(usuarioAutenticado.tokenServico.tokenJwt)
    if (!validarToken(usuarioAutenticado.tokenServico.tokenJwt)) {
      dispatch({
        type: AUTHENTICATION_FAILED,
        payload: { erro: 'Sessão Expirou' }
      })
    }
    const empresasOrdenadas = ordenarEmpresas(usuarioAutenticado.empresas);
    const authentication = {
      tokenJwt: usuarioAutenticado.tokenServico.tokenJwt,
      username: data.username,
      nomeUsuario: tokenDecodificado.nus,
      nomeUsuarioComNumero: tokenDecodificado.nomeUsuarioComNumero,
      idUsuario: tokenDecodificado.codigoUsuario,
      empresas: empresasOrdenadas,
      roles: usuarioAutenticado.tokenServico.roles,
      empresasSelecao: empresasOrdenadas,
      isAuthenticated: true
    };
    saveSecurityToken(authentication)

    return dispatch({
      type: USER_AUTHENTICATED,
      payload: authentication
    })
  })
  .catch(err => dispatch({
    type: AUTHENTICATION_FAILED,
    payload: { err }
  }))

export const logoutUser = () => {
  removeSecurityToken()
  return {
    type: USER_LOGOUT,
    payload: {
      tokenJwt: null,
      isAuthenticated: false,
      username: null
    }
  }
}
